/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from 'antd/componetns/typogrpahy/index.tsx
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import { Typography as AntdTypography } from 'antd';
import Text from './Text';
import Title from './Title';
import Paragraph from './Paragraph';
import Subtitle from './Subtitle';
import { ConfigContext } from '../config-provider';
// @ts-ignore
const InternalTypography = (props, ref) => {
    const { prefixCls: customizePrefixCls, ...restProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('typography', customizePrefixCls);
    // @ts-ignore
    return React.createElement(AntdTypography, { ref: ref, ...restProps, prefixCls: prefixCls });
};
const RefTypography = React.forwardRef(InternalTypography);
const Typography = RefTypography;
Typography.displayName = 'Typography';
Typography.Text = Text;
Typography.Title = Title;
Typography.Paragraph = Paragraph;
Typography.Subtitle = Subtitle;
// const ConfiguredTypography = withConfigProvider(Typography);
// export { ConfiguredTypography };
// export default ConfiguredTypography;
export { Typography };
export default Typography;
